import { addDays, differenceInCalendarDays, subDays } from "date-fns"

export default function (dateRange) {
  if (!dateRange.endDate) {
    return [
      {
        startDate: dateRange.startDate
      }
    ]
  }
  if (!dateRange.startDate) {
    const noOfSegments = 15
    const segmentSize = 5
    const segments = []
    for (let i = 0; i < noOfSegments; i++) {
      segments.push({
        startDate: subDays(dateRange.endDate, (i + 1) * segmentSize - 1),
        endDate: subDays(dateRange.endDate, i * segmentSize)
      })
    }
    segments.push({
      endDate: subDays(dateRange.endDate, noOfSegments * segmentSize)
    })
    return segments
  }
  const diff =
    differenceInCalendarDays(dateRange.endDate, dateRange.startDate) + 1

  const noOfSegments =
    diff > 150 ? 20 : diff > 70 ? 15 : diff > 25 ? 10 : diff > 6 ? 3 : 1

  const segmentSize = Math.ceil(diff / noOfSegments)
  const segments = []

  for (let i = 0; i < noOfSegments; i++) {
    const startDate = addDays(dateRange.startDate, i * segmentSize)
    const endDate = addDays(dateRange.startDate, (i + 1) * segmentSize - 1)

    if (differenceInCalendarDays(dateRange.endDate, endDate) <= 0) {
      segments.push({ startDate, endDate: dateRange.endDate })
      break
    }
    segments.push({ startDate, endDate })
  }
  return segments
}
